import React from 'react'
import {useTranslation} from '@lib/intl/useTranslations'

import {PORTFOLIO_REFRESH_INTERVAL, PRO_PORTFOLIO_REFRESH_INTERVAL} from '@constant/refreshInterval'
import {getNumberColorClass} from '@util/etc'
import useFormatNumber from '@hook/useFormatNumber'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'
import useQueryGetUserProfile from '@hook/query/portfolio/useQueryGetUserProfile'

import Text from '@component/Text/Text'
import MobileUserSharpRatioComponent from '@feature/portfolio/components/MobileUserProfileHeader/components/MobileUserSharpRatioComponent'

interface IProps {
    className?: string
    id?: string
    login_id?: string
}

const MobileUserScoreComponent = ({className, id, login_id}: IProps) => {
    const t = useTranslation()
    const {displayPercent} = useFormatNumber()

    const {data: me} = useQueryFetchMe(undefined, false)
    const {data: profile} = useQueryGetUserProfile(
        id,
        me?.is_pro && id === login_id ? PRO_PORTFOLIO_REFRESH_INTERVAL : PORTFOLIO_REFRESH_INTERVAL,
    )
    return (
        <div className={'flex-1 flex items-center justify-between'}>
            <div>
                <Text className={'text-body_comm text-gray02 dark:text-dark_gray02'}>
                    {t('balanceHeader.stats.24hour.title')}
                </Text>
                <Text className={`text-ti2 ${getNumberColorClass(profile?.daily_score)}`}>
                    {displayPercent(profile?.daily_score)}
                </Text>
            </div>
            <div>
                <Text className={'text-body_comm text-gray02 dark:text-dark_gray02'}>
                    {t('balanceHeader.stats.30days.title')}
                </Text>
                <Text className={`text-ti2 ${getNumberColorClass(profile?.monthly_score)}`}>
                    {displayPercent(profile?.monthly_score)}
                </Text>
            </div>
            <div>
                <Text className={'text-body_comm text-gray02 dark:text-dark_gray02'}>
                    {t('balanceHeader.stats.allTime.title')}
                </Text>
                <Text className={`text-ti2 ${getNumberColorClass(profile?.all_time_score)}`}>
                    {displayPercent(profile?.all_time_score)}
                </Text>
            </div>
            <MobileUserSharpRatioComponent id={id} login_id={login_id} />
        </div>
    )
}
export default MobileUserScoreComponent
